import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	list: []
};

export default function themes(state = initialState, action) {
	
	switch (action.type) {			

		case "IS_FETCHING":
			return update(state, { isFetching: { $set: action.bool } });

		case "SET_THEMES_LIST":
			return update(state, { list: { $set: action.themes } });		

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/domains/themes/reducer.js